<template lang="pug">
  v-navigation-drawer.main-sidebar(
    app
    fixed
    persistent
    v-model="onDrawerProp"
    )
    v-layout.mt-3(column align-center justify-center)
      img(
        src="@/assets/logo.png"
        height="130"
        )
    v-list.mt-3.transparent
      v-list-tile(
        v-for="(item, index) in sideBarRoutes"
        :key="index"
        :to="item.path"
        active-class="active"
        )
        v-list-tile-action
          v-icon(v-html="item.icon")
        v-list-tile-content
          v-list-tile-title.font-toolbar(v-text="item.title")
      v-list-group(
        v-for="item in sideBarRoutesGroup"
        :key="item.title"
      )
        v-list-tile(
          slot="activator"
          :id="item.title"
        )
          v-list-tile-action
            v-icon(v-html="item.icon")
          v-list-tile-content
            v-list-tile-title.font-toolbar(v-text="item.title")
        v-list-tile(
          v-for="itemChild in item.items"
          :key="itemChild.title"
          :id="itemChild.meta.title"
          :to="itemChild.path"
        )
          v-list-tile-action
            v-icon(v-html="itemChild.meta.icon")
          v-list-tile-content
            v-list-tile-title.font-toolbar(v-text="itemChild.meta.title")
</template>

<script>
import routes from '@/router/routes';
import LoginService from '@/services/LoginService';

export default {
  props: {
    drawer: Boolean,
  },
  created() {
    this.getFilialId();
  },
  computed: {
    onDrawerProp: {
      get() {
        return this.drawer;
      },
      set(newValue) {
        this.$emit('update:drawer', newValue);
      },
    },
    sideBarRoutes() {
      return routes
        .filter(route => route.meta.sidebar && !route.meta.group)
        .map(route => ({
          path: route.path,
          icon: route.meta.icon,
          title: route.meta.title,
        }));
    },
    sideBarRoutesGroup() {
      return routes
        .filter(route => route.meta.sidebar && route.meta.group)
        .map(route => ({
          path: route.path,
          icon: route.meta.icon,
          title: route.meta.title,
          items: route.children,
        }));
    },
  },
  methods: {
    getFilialId() {
      LoginService
        .obterDadosFilial()
        .then(({ data }) => {
          localStorage.setItem('filialId', data.filialId);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/arch/Sidebar.vue